/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;

  var search = function search() {
    console.log($("#keyword").val());
    $f7.request({
      method: 'get',
      url: 'https://gdlotto.net/api/longlong/',
      data: {
        keyw: $("#keyword").val()
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        var data = JSON.parse(data);
        console.log(data);

        if (data.isSuccess == true) {
          var htmltext = "\n          <div class=\"card data-table\">\n              <table>\n                <thead>\n                  <tr>\n                    <th class=\"label-cell\">Number</th>\n                    <th class=\"numeric-cell\"></th>\n                    <th class=\"numeric-cell\">Description</th>\n                  </tr>\n                </thead>\n                <tbody>\n          ";

          for (var i = 0; i < data.Result.length; i++) {
            var desc1 = data.Result[i]["cat1_desc_" + window.lang.replace("tl", "tn")];
            var desc2 = data.Result[i]["cat2_desc_" + window.lang.replace("tl", "tn")];
            if (desc1 == null) desc1 = "";
            if (desc2 == null) desc2 = "";
            htmltext += " \n                  <tr>\n                    <td class=\"label-cell\">" + data.Result[i].number + "</td>\n                    <td class=\"numeric-cell\">" + desc1 + "</td>\n                    <td class=\"numeric-cell\">" + desc2 + "</td>\n                  </tr>\n\n            ";
            console.log("cat2_desc_" + window.lang.replace("tl", "tn"));
            console.log(data);
          }

          htmltext += "\n                </tbody>\n              </table>\n            </div>\n          ";
          $(".show_longlong").html(htmltext);
        } else {
          $f7.dialog.alert(data.ErrorMessage);
        }
      }
    });
  };

  $on('pageInit', function () {
    $("#keyword").focus();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">
        <span class='en'>Long Long Number</span>
        <span class='cn'>Long Long 号码</span>
        <span class='tl'>Long Long númeru</span>
      </div>
    </div>
  </div>
  <div class="page-content">

    <div class="block-title">
      <span class='en'>Long Long number</span>
      <span class='cn'>Long Long 号码</span>
      <span class='tl'>Long Long númeru</span>
    </div>
    <div class="block">
      
        <span class='en'>Please enter keyword to retrieve Long Long number</span>
        <span class='cn'>请输入关键字搜索 Long Long 号码</span>
        <span class='tl'>Favór ida, tama iha uma-na'in atu retrieve Long Long.</span>
      
    </div>

    <div class="list  inline-labels inset">
      <ul>  
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>Keyword</span>
              <span class='cn'>关键字</span>
              <span class='tl'>liafuan xave</span>
            </div>
            <div class="item-input-wrap">
              <input type="text" value="" placeholder="" id="keyword" />
            </div>
          </div>
        </li>    
        <li>
          <p class="segmented">
            <button class="button"></button>
            <button class="button"></button>
            <button class="button button-fill button-active" @click="${search}">
              <span class='en'>Search</span>
              <span class='cn'>搜索</span>
              <span class='tl'>Buka</span>
            </button>
            <span class="segmented-highlight"></span>
          </p>
        </li>
      </ul>
    </div>
    <div class="show_longlong">

    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '69edbda470';
export default framework7Component;